// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5c0bf450","667":"dc6007d0","977":"aee5e34f"}[chunkId] + ".chunk.js";
};